
type imageLinkProps = {
    src: string,
    link: string,
}

export default function ImageLink({ src, link }: imageLinkProps) {
    return (
        <a href={link} target="_blank" rel="noreferrer" className="tw-flex-shrink-0">
            <img
                src={src}
                alt="icon"
                height={120}
                className="tw-h-[120px] tw-w-auto tw-transition-transform tw-duration-300 tw-ease-in-out hover:tw-scale-110"
                title="Visitar"
            />
        </a>
    )
}